<div class="databox">
  @for (item of states(); track $index) {
    <app-icon-state [config]="item.state" [state]="item.stateName" />
  }
</div>
